import { ChiliHotIcon } from './ChiliHotIcon';

/**
 * author: Andy Martinez
 * id E868226C-7BE8-4A22-8A9A-8E040004016A
 * name chili-hot
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chili-hot.svg
 * tags
 * - Food / Drink 
 */
export const PepperIcon = ChiliHotIcon;
export default PepperIcon